import { Routes } from '@angular/router';
import {authGuard} from "../core/guard/auth.guard";
import {checkLoginGuardGuard} from "../core/guard/check-login-guard.guard";
import {ResetPasswordComponent} from "../components/auth/reset-password/reset-password.component";

export const routes: Routes = [
    {
        path: 'set-password/:id',
        title: 'Set Password',
        component: ResetPasswordComponent,
    },
  {path: '', canActivate: [checkLoginGuardGuard], loadChildren: () => import('./../components/auth/auth.route').then(m => m.authRoutes)},
  {path: '',  canActivate: [authGuard], loadChildren: () => import('./../components/home/home.route').then(m => m.homeRoutes)},
  {path: '**', redirectTo: ''}
];
